


<div style="">


  <nz-table
    #dataTable

    [nzData]="d.current || []"
    [nzPageSize]="1000"
    [nzShowPagination]="false"
    [nzLoading]="d.loading"
    nzSize="small"
    class="nz-table-xs"

    >

    <thead>
      <tr>

        @for (h of d.header || []; track h; let i = $index) {
          <th
            [nzAlign]="findAlign(h.align)"
            [nzSortFn]="h.disableSort ? undefined : sortFns[i]"
            [nzWidth]="h.width"
            >
            {{ h.text }}
          </th>
        }

      </tr>

    </thead>
    <tbody>
      @for (row of dataTable.data; track row) {
        <tr >
          @for (c of row.items || []; track c; let i = $index) {
            <td
              [nzAlign]="findAlign(d.header[i].align)"
              [class]="c.css"
              >
              <span>
                @switch (d.header[i].customType) {
                  @case ('bid') {
                    <span >
                      <a
              [href]="bas.ui.getRouterPrefix() + '/lib/goto?goto-action=order&goto-id='+c.text"
              target="_blank"
              [title]="'common.edit' | actrans" >
                        {{ c.text }}
                      </a>
                      <!--
                      (click)="$event.preventDefault(); openOrder(c.text)"-->
                    </span>
                  }
                  @case ('button') {
                    <span >
                      <button
                        nz-button
                        nzType="default"
                        nzSize="small"
                        (click)="$event.preventDefault(); miscStatsAction(c, d.header[i])"
                        [title]="c.title"
                        >
                        @if (c.icon) {
                          <span nz-icon [nzType]="c.icon" nzTheme="outline"></span>
                        }
                        @if (c.text) {
                          <span>{{ c.text | actrans }}  </span>
                        }
                      </button>
                    </span>
                  }
                  @default {
                    <span  [innerHtml]="bas.ui.fixNewline( c.text )">
                    </span>
                  }
                }
              </span>
            </td>
          }
        </tr>
      }
      <tr>
        <td colspan="20">&nbsp;</td>
      </tr>
    </tbody>
    @if (d.footer?.length) {
      <tfoot>
        <tr>
          @for (f of d.footer || []; track f; let i = $index) {
            <th
              [nzAlign]="d.header[i].align == 'right' ? 'right' : null"
              >
              {{ f.text }}
            </th>
          }
        </tr>
      </tfoot>
    }
  </nz-table>




</div>


<nz-modal
  [(nzVisible)]="msad.visible"
  [nzTitle]="msad.cellHeader?.customTypeName || ('common.info' | actrans | str)"
  nzWidth="90vw"
  (nzOnCancel)="msad.visible = false;"
  (nzOnOk)="msad.visible = false;"
  [nzOkText]="'common.close' | actrans | str"
  [nzCancelText]="null" >
  <ng-container *nzModalContent>
    <div class="table-responsive-wrapper">
      <bt-table-data [data]="msad"></bt-table-data>
    </div>

  </ng-container>
</nz-modal>

